<template>
  <div class="main_content" style="min-width:1066px">
    <marketing-top-tittle></marketing-top-tittle>
    <div class="tab-line">
      <div class="tab-item" @click="selectIndex = 1" :class="{ active: selectIndex == 1 }"
        :style="{ color: selectIndex == 1 ? globalBG : '', 'border-top': selectIndex == 1 ? '2px solid ' + globalBG : '' }">
        {{ tittle }}
        <span></span>
      </div>
      <div class="tab-item" @click="selectIndex = 2" :class="{ active: selectIndex == 2 }"
        :style="{ color: selectIndex == 2 ? globalBG : '', 'border-top': selectIndex == 2 ? '2px solid ' + globalBG : '' }">
        短信记录
        <span></span>
      </div>
      <div class="tab-item" @click="selectIndex = 3" :class="{ active: selectIndex == 3 }"
        :style="{ color: selectIndex == 3 ? globalBG : '', 'border-top': selectIndex == 3 ? '2px solid ' + globalBG : '' }">
        营销效果
        <span></span>
      </div>
    </div>
    <div class="tab_item_box">
      <template v-if="selectIndex == 1">
        <task-table ref="task" :pageName="pageName + tittle"></task-table>
      </template>
      <template v-if="selectIndex == 2">
        <sms-record-table ref="sms"></sms-record-table>
      </template>
      <template v-if="selectIndex == 3">
        <market-analysis ref="analysis" :selectIndex="selectIndex"></market-analysis>
      </template>
    </div>
  </div>
</template>

<script>
import taskTable from "./component/taskTable";
import smsRecordTable from "./component/smsRecordTable";
import marketAnalysis from "./component/marketAnalysis";
import { page, getRemind, getRemindByTime } from "@/api/care/orderCare";
import pageCondition from "./page-condition.vue";
import marketingTopTittle from "./component/marketingTopTittle";
import { mapState } from "vuex";
export default {
  components: {
    marketingTopTittle,
    taskTable,
    smsRecordTable,
    marketAnalysis,
  },
  data() {
    return {
      pageName: "客户营销-自动化营销",
      selectIndex: 1,
      tableList: [
        // {
        //     taskName: "任务名称110",
        //     batchCount: "短信内容666",
        //     createdTime: "2020-06-16 15:46:50",
        //     taskType: 1,
        //     precedenceLevel: 2,
        //     isOpen: "1",
        // },
      ],
      // 表格数据
      smsTableList: [
        {
          buyerNick: "crs1633489851",
          mobile: "13143364649",
          star: 3,
          comfrom: "常规催付",
          content:
            "【阿狸小姐的店大萨对方过后】5-13test 常规催付 亲爱的！您在小店拍下的宝贝还未付款，宝贝已经等不及了，非要和你回家，快来,收了它吧~~点击 120.79.18.7:18896/WAF1sas",
          sendTime: "2020-05-13 14:40:32",
          smsNumber: "2",
          status: "1",
          tid: "997185729540957961",
        },
        {
          buyerNick: "crs1633489851",
          mobile: "13143364649",
          star: 4,
          comfrom: "常规催付",
          content:
            "【阿狸小姐的店大萨对方过后】5-13test 常规催付 亲爱的！您在小店拍下的宝贝还未付款，宝贝已经等不及了，非要和你回家，快来          ,收了它吧~~点击 120.79.18.7:18896/WAF1sas",
          sendTime: "2020-05-13 14:40:32",
          smsNumber: "2",
          status: "1",
          tid: "997185729540957961",
        },
      ],
    };
  },
  computed: {
    tittle() {
      return this.$route.name;
    },
    menuIndex() {
      return this.$route.meta.itemIndex;
    },
    taskTypeActive() {
      return this.$route.meta.taskType;
    },
    ...mapState({
      globalBG: "globalBG",
    }),
  },
  created() {
    console.log(this.menuIndex, '1111111111111112222222222222222');
    // 调用埋点接口
    let name
    if (this.menuIndex == 1) name = '商品复购'
    if (this.menuIndex == 2) name = '首购有礼'
    if (this.menuIndex == 3) name = '复购有礼'
    if (this.menuIndex == 4) name = '休眠提醒'
    if (this.menuIndex == 5) name = '满月礼'
    if (this.menuIndex == 6) name = '百日礼'
    if (this.menuIndex == 7) name = '周年庆'
    this.buriedPoint(1, name, '客户营销', '自动化营销')
  },
  mounted() {
    if (this.$route.query.industry) {
      this.selectIndex = 2
    }
  },
  methods: {
    /***
     * 短信记录-查询
     * */
    getSmsSentRecordList() {
      this.talbeLoading1 = true;
      let params = { ...this.smsSearchParams };
      for (var i in params) {
        if (params[i] == "") {
          delete params[i];
        }
      }
      getSmsSentRecordList({
        taskType: this.taskTypeActive,
        ...params,
      }).then(({ data }) => {
        // console.log(res);
        this.smsTableList = data.records;
        this.smsTableTotalCount = Number(data.total);
        this.talbeLoading1 = false;
      });
    },

    getRangeCount() { },
  },
};
</script>

<style lang="scss" scoped>
.main_content {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  opacity: 1;
  border-radius: 6px;
  margin: 20px;

  .tab-line {
    font-size: 14px;
    color: #666;
    border-bottom: 1px solid #dddddd;
    margin: 20px 28px 0 28px;

    .tab-item {
      // padding: 15px 0;
      text-align: center;
      width: 106px;
      height: 36px;
      line-height: 36px;
      display: inline-block;
      position: relative;
      cursor: pointer;
      margin-right: 2px;
      border: 1px solid #dddddd;
      border-bottom: none;

      // &:first-child{
      //   margin-right: 22px;
      // }
      span {
        position: absolute;
        width: 100%;
        left: 50%;
        height: 2px;
        transform: translateX(-50%);
        bottom: -2px;
        display: none;
      }

      &.active {
        border-top: 2px;

        span {
          display: block;
          background: #fff;
        }
      }
    }
  }
}

.tab_item_box {
  padding: 20px 25px 30px;
}
</style>
